
/* ========================================
   JUSTGETSTARTEDAI THEME JS v1.1
   ======================================== */

'use strict';

function escapeHTML(value) {
  const element = document.createElement('div');
  element.textContent = value == null ? '' : String(value);
  return element.innerHTML;
}

function safeImageUrl(value) {
  try {
    const url = new URL(value, window.location.origin);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
  } catch (_) {
    return '';
  }
}

function setButtonLabel(button, label) {
  if (!button) return;
  const labelElement = button.querySelector('span');
  if (labelElement) labelElement.textContent = label;
  else button.textContent = label;
}

// ── NAV SCROLL ──
(function() {
  const nav = document.getElementById('SiteHeader');
  if (!nav) return;
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        nav.classList.toggle('scrolled', window.scrollY > 30);
        ticking = false;
      });
      ticking = true;
    }
  });
})();

// ── MOBILE MENU ──
(function() {
  const toggle = document.getElementById('MobileMenuToggle');
  const menu = document.getElementById('MobileMenu');
  if (!toggle || !menu) return;

  toggle.addEventListener('click', function() {
    const isOpen = menu.classList.toggle('open');
    toggle.classList.toggle('open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen);
    menu.setAttribute('aria-hidden', String(!isOpen));
    menu.inert = !isOpen;
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  window.closeMobileMenu = function() {
    menu.classList.remove('open');
    toggle.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    menu.inert = true;
    document.body.style.overflow = '';
  };
})();

// ── CART DRAWER ──
(function() {
  const overlay = document.getElementById('CartOverlay');
  const toggle = document.getElementById('CartToggle');
  const closeBtn = document.getElementById('CartClose');
  const continueBtn = document.getElementById('CartContinue');
  const checkoutBtn = document.getElementById('CartCheckout');

  if (!overlay) return;

  window.openCart = function() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.inert = false;
    document.body.style.overflow = 'hidden';
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    fetchCart();
    overlay.querySelector('.cart-drawer')?.focus();
  };

  window.closeCart = function() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.inert = true;
    document.body.style.overflow = '';
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  };

  if (toggle) toggle.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (continueBtn) continueBtn.addEventListener('click', closeCart);

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeCart();
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      window.location.href = '/checkout';
    });
  }

  // Fetch and render cart
  window.fetchCart = function() {
    fetch('/cart.js')
      .then(r => {
        if (!r.ok) throw new Error('Unable to load cart');
        return r.json();
      })
      .then(cart => {
        window.renderCart(cart);
        updateCartCount(cart.item_count);
      })
      .catch(console.error);
  };

  window.renderCart = function(cart) {
    const body = document.getElementById('CartBody');
    const totalEl = document.getElementById('CartSubtotal');
    if (typeof updateFreeShipBar === 'function') updateFreeShipBar(cart);
    if (!body) return;

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty-icon">👕</div><div class="cart-empty-text">Your cart is empty</div><div class="cart-empty-sub">Start building your custom order</div></div>';
      return;
    }

    body.innerHTML = cart.items.map(item => {
      const image = safeImageUrl(item.image);
      const key = escapeHTML(item.key);
      return `
      <div class="cart-item" data-key="${item.key}">
        <div class="ci-img">
          ${image
            ? `<img src="${image}" alt="${escapeHTML(item.title)}" loading="lazy">`
            : `<div class="ci-img-fallback">👕</div>`}
        </div>
        <div class="ci-info">
          <div class="ci-name">${escapeHTML(item.product_title)}</div>
          <div class="ci-variant">${item.variant_title && item.variant_title !== 'Default Title' ? escapeHTML(item.variant_title) : ''}</div>
          <div class="ci-price-row">
            <div class="ci-price">${formatMoney(item.line_price)}</div>
            <div class="ci-qty">
              <button class="ci-qty-btn" onclick="updateCartItem('${key}', ${item.quantity - 1})" aria-label="Decrease ${escapeHTML(item.product_title)} quantity">−</button>
              <span class="ci-qty-num">${item.quantity}</span>
              <button class="ci-qty-btn" onclick="updateCartItem('${key}', ${item.quantity + 1})" aria-label="Increase ${escapeHTML(item.product_title)} quantity">+</button>
            </div>
          </div>
        </div>
        <button class="ci-rm" onclick="updateCartItem('${key}', 0)" aria-label="Remove ${escapeHTML(item.product_title)}">✕</button>
      </div>
    `;
    }).join('');
  };
})();

// ── CART API ──
window.updateCartItem = function(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(r => {
    if (!r.ok) throw new Error('Unable to update cart');
    return r.json();
  })
  .then(cart => {
    if (typeof window.renderCart === 'function') window.renderCart(cart);
    updateCartCount(cart.item_count);
    if (document.querySelector('.cart-page')) window.location.reload();
  })
  .catch(console.error);
};

window.addToCartAjax = function(variantId, qty, callback) {
  qty = qty || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .then(r => r.json().then(data => {
    if (!r.ok) throw new Error(data.description || 'Unable to add item');
    return data;
  }))
  .then(item => {
    window.openCart?.();
    showToast('✅ Added to cart: ' + item.product_title, 'success');
  })
  .catch(err => {
    showToast('⚠️ ' + (err.message || 'Could not add to cart. Please try again.'));
    console.error(err);
  })
  .finally(() => {
    if (callback) callback();
  });
};

window.quickAdd = function(variantId, title, price, image) {
  addToCartAjax(variantId, 1);
};

window.updateCartCount = function(count) {
  const badge = document.getElementById('CartCount');
  if (!badge) return;
  badge.textContent = count;
  badge.style.display = count > 0 ? 'flex' : 'none';
};

// ── PRODUCT FORM ──
(function() {
  const form = document.getElementById('ProductForm');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn = document.getElementById('AddToCartBtn');
    if (btn) {
      btn.disabled = true;
      setButtonLabel(btn, 'Adding...');
    }

    const variantId = document.getElementById('ProductVariantId')
      ? document.getElementById('ProductVariantId').value
      : new FormData(form).get('id');
    const qty = parseInt(document.getElementById('ProductQty')?.value || 1);

    addToCartAjax(variantId, qty, function() {
      if (btn) {
        btn.disabled = false;
        setButtonLabel(btn, 'Add to Cart 🛒');
      }
    });
  });
})();

// ── PRODUCT VARIANT SELECTOR ──
window.selectVariantOption = function(btn, optionIndex, value) {
  // Deselect siblings
  btn.closest('.size-options, .color-options, .option-pills')
    ?.querySelectorAll('.size-btn, .color-btn, .option-pill')
    .forEach(b => {
      b.classList.remove('selected');
      b.setAttribute('aria-checked', 'false');
    });
  btn.classList.add('selected');
  btn.setAttribute('aria-checked', 'true');

  // Update color display
  if (btn.closest('.color-options')) {
    const display = document.getElementById('ColorDisplay');
    if (display) display.textContent = value;
  }

  // Find matching variant
  if (!window.productData) return;
  const selected = [];
  document.querySelectorAll('.size-btn.selected, .color-btn.selected, .option-pill.selected').forEach(b => {
    const idx = parseInt(b.dataset.optionIndex);
    selected[idx] = b.dataset.value;
  });

  const variant = window.productData.variants.find(v =>
    v.options.every((opt, i) => !selected[i] || selected[i] === opt)
  );

  if (variant) {
    const idInput = document.getElementById('ProductVariantId');
    if (idInput) idInput.value = variant.id;
    const priceEl = document.querySelector('.price-current');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    const addBtn = document.getElementById('AddToCartBtn');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      setButtonLabel(addBtn, variant.available ? 'Add to Cart 🛒' : 'Sold Out');
    }
    // Update URL
    history.replaceState({}, '', `?variant=${variant.id}`);
  }
};

// ── PRODUCT GALLERY ──
window.switchImage = function(btn, src) {
  const mainImg = document.getElementById('ProductMainImage');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
};

// ── QUANTITY ──
window.changeQty = function(delta) {
  const input = document.getElementById('ProductQty');
  if (!input) return;
  const val = Math.max(1, parseInt(input.value || 1) + delta);
  input.value = val;
};

// ── BUY NOW ──
window.buyNow = function() {
  const variantId = document.getElementById('ProductVariantId')?.value
    || window.productData?.selectedVariantId;
  const qty = document.getElementById('ProductQty')?.value || 1;
  if (variantId) {
    window.location.href = `/cart/${variantId}:${qty}?checkout`;
  }
};

// ── SIZE GUIDE ──
window.openSizeGuide = function() {
  const modal = document.getElementById('SizeGuideModal');
  if (modal) {
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    modal.inert = false;
    document.body.style.overflow = 'hidden';
    modal.querySelector('.modal-box')?.focus();
  }
};
window.closeSizeGuide = function() {
  const modal = document.getElementById('SizeGuideModal');
  if (modal) {
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    modal.inert = true;
    document.body.style.overflow = '';
  }
};
document.addEventListener('click', function(e) {
  if (e.target.id === 'SizeGuideModal') closeSizeGuide();
});
document.getElementById('SizeGuideToggle')?.addEventListener('click', openSizeGuide);

// ── SEARCH ──
(function() {
  const toggle = document.getElementById('SearchToggle');
  const overlay = document.getElementById('SearchOverlay');
  const closeBtn = document.getElementById('SearchClose');
  const input = document.getElementById('SearchInput');
  if (!overlay) return;

  toggle?.addEventListener('click', function() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.inert = false;
    toggle?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input?.focus(), 100);
  });
  closeBtn?.addEventListener('click', closeSearch);
  overlay?.addEventListener('click', function(e) { if (e.target === overlay) closeSearch(); });
  function closeSearch() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.inert = true;
    toggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  let searchTimeout;
  input?.addEventListener('input', function() {
    clearTimeout(searchTimeout);
    const q = this.value.trim();
    if (q.length < 2) {
      document.getElementById('SearchResults').innerHTML = '<div class="search-hint">Type to search products...</div>';
      return;
    }
    searchTimeout = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`)
        .then(r => r.json())
        .then(data => {
          const results = data.resources?.results?.products || [];
          const el = document.getElementById('SearchResults');
          if (!el) return;
          if (results.length === 0) {
            el.innerHTML = '<div class="search-hint">No products found</div>';
            return;
          }
          el.innerHTML = results.map(p => {
            const image = safeImageUrl(p.featured_image?.url || '');
            return `
            <a href="${p.url}" style="display:flex;align-items:center;gap:12px;padding:10px;border-radius:8px;transition:background .15s;color:var(--ink)" onmouseover="this.style.background='var(--bg)'" onmouseout="this.style.background=''">
              ${image ? `<img src="${image}" alt="${escapeHTML(p.title)}" style="width:44px;height:44px;object-fit:cover;border-radius:8px;border:1px solid var(--border);background:var(--bg)">` : ''}
              <div>
                <div style="font-size:14px;font-weight:600">${escapeHTML(p.title)}</div>
                <div style="font-size:12px;color:var(--muted)">${escapeHTML(p.price)}</div>
              </div>
            </a>
          `;
          }).join('');
        });
    }, 300);
  });

  input?.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') window.location.href = `/search?q=${encodeURIComponent(this.value)}`;
  });
})();

// ── FAQ ACCORDION ──
window.toggleFAQ = function(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => {
    i.classList.remove('open');
    i.querySelector('.faq-q')?.setAttribute('aria-expanded', 'false');
  });
  if (!isOpen) {
    item.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
  }
};

// ── HERO COUNTDOWN ──
(function() {
  const heroEl = document.getElementById('HeroDaysCD');
  if (!heroEl) return;
  const targetValue = heroEl.dataset.countdownDate;
  const target = targetValue ? new Date(targetValue) : null;
  function update() {
    if (!target || Number.isNaN(target.getTime())) {
      heroEl.textContent = 'Soon';
      return;
    }
    const now = new Date();
    const diff = Math.max(0, target - now);
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const pad = n => String(n).padStart(2, '0');
    heroEl.textContent = diff > 0 ? d : 'Live';
  }
  setInterval(update, 1000);
  update();
})();

// ── SCROLL REVEAL ──
(function() {
  if (!document.body.classList.contains('animations-on')) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.rv, .rv2').forEach(el => obs.observe(el));
})();

// ── TOAST ──
window.showToast = function(msg, type) {
  const toast = document.getElementById('Toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.className = type === 'success' ? 'show success' : 'show';
  clearTimeout(toast._timeout);
  toast._timeout = setTimeout(() => toast.classList.remove('show'), 3000);
};

// ── MONEY FORMAT ──
window.formatMoney = function(cents) {
  const format = window.shopData?.moneyFormat || '${{amount}}';
  const value = Number(cents || 0) / 100;
  const formats = {
    amount: value.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    amount_no_decimals: Math.round(value).toLocaleString('en-CA'),
    amount_with_comma_separator: value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    amount_no_decimals_with_comma_separator: Math.round(value).toLocaleString('de-DE'),
    amount_with_apostrophe_separator: value.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => formats[key] ?? formats.amount);
};

// ── INIT ──
document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.fetchCart === 'function') window.fetchCart();
  document.querySelectorAll('.faq-q').forEach(button => button.setAttribute('aria-expanded', 'false'));
});

// ══════════════════════════════════════════
// 2026 TREND UPDATES — configurable drop countdowns
// ══════════════════════════════════════════

// ── DROP COUNTDOWN (per-section, reads data-drop-countdown target date) ──
(function() {
  var blocks = document.querySelectorAll('[data-drop-countdown]');
  if (!blocks.length) return;

  function update() {
    blocks.forEach(function(block) {
      var target = new Date(block.getAttribute('data-drop-countdown'));
      if (isNaN(target.getTime())) return;
      var diff = Math.max(0, target - new Date());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var pad = function(n){ return String(n).padStart(2,'0'); };
      var set = function(sel, val){ var el = block.querySelector(sel); if (el) el.textContent = pad(val); };
      set('[data-cd="d"]', d);
      set('[data-cd="h"]', h);
      set('[data-cd="m"]', m);
      set('[data-cd="s"]', s);
    });
  }
  setInterval(update, 1000);
  update();
})();

// ══════════════════════════════════════════
// CONVERSION OPTIMIZATION LAYER
// ══════════════════════════════════════════

// ── STICKY MOBILE ADD-TO-CART BAR ──
(function() {
  const bar = document.getElementById('StickyAtcBar');
  const mainBtn = document.getElementById('AddToCartBtn');
  if (!bar || !mainBtn) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      bar.classList.toggle('show', !entry.isIntersecting && window.scrollY > 200);
    });
  }, { threshold: 0 });
  observer.observe(mainBtn);

  window.addEventListener('scroll', () => {
    if (window.scrollY < 200) bar.classList.remove('show');
  });
})();

// ── FREE SHIPPING PROGRESS BAR ──
function updateFreeShipBar(cart) {
  const bar = document.getElementById('FreeShipFill');
  const text = document.getElementById('FreeShipText');
  if (!bar || !text) return;

  const threshold = parseInt(window.shopData?.freeShippingThreshold || 0, 10);
  if (!threshold) return;

  const total = cart.total_price / 100;
  const pct = Math.min(100, (total / threshold) * 100);
  bar.style.width = pct + '%';

  if (total >= threshold) {
    text.innerHTML = '🎉 You\u2019ve unlocked free shipping!';
    text.classList.add('reached');
  } else {
    const remaining = (threshold - total).toFixed(2);
    text.innerHTML = `You're <b>${formatMoney(Math.round(remaining * 100))}</b> away from free shipping`;
    text.classList.remove('reached');
  }
}

// Free shipping bar is updated directly inside renderCart (see cart-drawer IIFE below)

// ── EXIT INTENT ──
(function() {
  const overlay = document.getElementById('ExitIntentOverlay');
  if (!overlay) return;

  const closeBtn = document.getElementById('ExitIntentClose');
  const SESSION_KEY = 'flamez_exit_intent_shown';

  function showPopup() {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    overlay.classList.add('show');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.inert = false;
    sessionStorage.setItem(SESSION_KEY, '1');
  }
  function hidePopup() {
    overlay.classList.remove('show');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.inert = true;
  }

  // Desktop only — cursor leaving toward the top of the viewport
  let armed = false;
  setTimeout(() => { armed = true; }, 4000); // don't fire in the first few seconds

  document.addEventListener('mouseout', (e) => {
    if (!armed || e.clientY > 0 || e.relatedTarget) return;
    showPopup();
  });

  closeBtn?.addEventListener('click', hidePopup);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) hidePopup(); });

})();

// Close transient UI with Escape. This also restores page scrolling.
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  window.closeCart?.();
  window.closeMobileMenu?.();
  window.closeSizeGuide?.();
  const search = document.getElementById('SearchOverlay');
  if (search?.classList.contains('open')) document.getElementById('SearchClose')?.click();
  document.getElementById('ExitIntentOverlay')?.classList.remove('show');
  const exitOverlay = document.getElementById('ExitIntentOverlay');
  if (exitOverlay) {
    exitOverlay.setAttribute('aria-hidden', 'true');
    exitOverlay.inert = true;
  }
});

// Merchant-confirmed purchase notice. No simulated orders, timer claims or customer details.
(function () {
  const notice = document.getElementById('RecentPurchaseNotice');
  if (!notice) return;
  const key = 'jgs_recent_purchase_dismissed';
  try { if (sessionStorage.getItem(key)) return; } catch (_) { /* Storage may be unavailable. */ }
  const close = () => {
    notice.hidden = true;
    try { sessionStorage.setItem(key, '1'); } catch (_) { /* Ignore blocked storage. */ }
  };
  document.getElementById('RecentPurchaseClose')?.addEventListener('click', close);
  window.setTimeout(() => { if (!document.hidden) notice.hidden = false; }, 5000);
})();
